import React from 'react';


function Footer() {
  return (
    <div>
        <footer>
            <h2><a href="https://github.com/omarkawach/Info-Viz">Data Sources and Code Available on GitHub</a></h2>
        </footer>
    </div>
  )
}

export default Footer